import { useContext } from 'react'
import CasoContext from '../store/CasoContext'

const useFormatoActual = () => {
  const context = useContext(CasoContext)

  const setFormatoActual = (formato: string, color: string, imageSrc:string) => {
    context?.updateField('appFormato', formato)
    context?.updateField('appColor', color)
    context?.updateField('appLogo', imageSrc)
  }

  return setFormatoActual
}

export default useFormatoActual
